import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distict-form',
  templateUrl: './distict-form.component.html',
  styleUrls: ['./distict-form.component.css']
})
export class DistictFormComponent implements OnInit {
  title="Add District";
  constructor() { }

  ngOnInit() {
  }

  table = [
    {"districtId" :"101" ,"districtName":"Balkot"  },
    {"districtId" :"102" ,"districtName":"Banglore"  }
  ]

}



// WEBPACK FOOTER //
// ./src/app/pages/master/district/distict-form/distict-form.component.ts